/**
 * Business time — TIFPA operates on US Central time (America/Chicago).
 *
 * Anything that WRITES shared business data (workflow stamps, month-sheet
 * selection, walk-in appointment times) must use these helpers instead of the
 * viewer's local clock, so a remote or misconfigured machine can't stamp the
 * wrong day/month into shared sheets. Display of activity timestamps stays
 * viewer-local by design.
 *
 * Built on Intl only — no timezone library needed (en-CA formats YYYY-MM-DD).
 */

const dayFmt = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Chicago',
});

/** Central-time calendar date (YYYY-MM-DD) of a timestamp */
export const centralDateOf = (ts: Date | string | number): string =>
  dayFmt.format(new Date(ts));

/** Today's date in Central time (YYYY-MM-DD) */
export const centralToday = (): string => centralDateOf(new Date());

/** Current Central month (YYYY-MM) */
export const centralMonth = (): string => centralToday().slice(0, 7);

/** Current Central year */
export const centralYear = (): number => Number(centralToday().slice(0, 4));

const timeFmt = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'America/Chicago',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

/** Current Central wall-clock time (HH:MM) — e.g. for walk-in "now" slots */
export const centralNowHHMM = (): string => timeFmt.format(new Date());
